import './MeditationFullscreen.scss'

import { useEffect } from 'react'
import { Col, Button, Row, Container } from 'react-bootstrap'
import { useHistory, useParams } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import parse from 'html-react-parser'

import { getMeditationData } from '../../../common/api/Practices'
import { navigateTo } from 'components/common/navigation'
import { ROUTE_ACTIVITIES_MEDITATION_ALL } from '../../../common/helpers/Paths'
import Author from '../../Author'
import useFetchByID from '../../../common/hooks/useFetchByID'
import { getFullAuthorById } from '../../../common/api/Courses'
import MeditationCard from '../MeditationCard/MeditationCard'
import BlobAnimation from '../../BlobAnimation'
import Loading from '../../../../templates/Loading'
import WebShare from '../../../web-share'
import {
  saveUserEvent,
  EVENT_CATEGORY_MEDITATION,
  EVENT_ACTION_PAGEVIEW
} from '../../../common/api/UserEvents'
import Bookmark from 'components/bookmark/Bookmark'
import { KEY_PRACTICE_MEDITATIONS_WP } from 'components/common/api'

function MeditationFullscreen({ setReturnPath, setHeaderTitle, cache }) {
  const { meditationId } = useParams()
  const history = useHistory()
  const cacheKey = `${ROUTE_ACTIVITIES_MEDITATION_ALL}/intro/${meditationId}`
  const isLargeScreen = useMediaQuery({ minWidth: 768 })

  const { data, isLoaded } = useFetchByID(
    getMeditationData,
    meditationId,
    cache,
    cacheKey
  )

  const authorID = data && data?.acf?.content_author[0]

  const author = useFetchByID(
    getFullAuthorById,
    authorID,
    cache,
    cacheKey + '/author'
  ).data

  useEffect(() => {
    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_MEDITATION_ALL)

    saveUserEvent(
      EVENT_CATEGORY_MEDITATION,
      EVENT_ACTION_PAGEVIEW,
      meditationId
    )
  }, [setReturnPath, setHeaderTitle, meditationId])

  const handleLetsMeditateButton = () => {
    navigateTo(
      `${ROUTE_ACTIVITIES_MEDITATION_ALL}/${meditationId}/meditate`,
      history
    )
  }

  return (
    <Loading isLoaded={!isLoaded}>
      <BlobAnimation />
      <div className='position-absolute meditation-share-button'>
        <Bookmark
          category={KEY_PRACTICE_MEDITATIONS_WP}
          categoryObjectId={meditationId}
        />
        <WebShare
          text={data?.title?.rendered}
          size='fs-5'
          color={isLargeScreen ? 'text-black' : 'text-white'}
        />
      </div>
      <div className='meditation-fullscreen-container'>
        <div className='meditation-content-container'>
          <div className='meditation-title-row px-4 pt-5 intro-cover'>
            <Row className='meditation-title-header pt-4 px-2'>
              <Col xs={12} md={6} className='meditation-title'>
                <h1>{data.title?.rendered && parse(data.title.rendered)}</h1>
              </Col>

              <Col md={6} className='meditation-call-for-action'>
                <Button onClick={handleLetsMeditateButton} size='lg'>
                  Let's meditate
                </Button>
              </Col>
            </Row>
          </div>
          <MeditationCard
            meditationData={data}
            hideCard={handleLetsMeditateButton}
          />
        </div>
        <Container fluid className='about-authors pb-5 pt-2 mx-1'>
          {author && (
            <Row>
              <Col md={12} className='author-heading'>
                <h3 className='mb-0'>About the author</h3>
              </Col>
              <Col md={12}>
                <Author author={author} />
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </Loading>
  )
}

export default MeditationFullscreen
